import GuestHeaderLinks from '@/components/Navigation/GuestHeaderLinks';
import Hamburger from '@/components/Navigation/Hamburger.tex';
import Logo from '@/components/Navigation/Logo';
import UserHeaderLinks from '@/components/Navigation/UserHeaderLinks';
import {useUserContext} from '@/components/Providers/UserContext';
import {Box, Stack, useMediaQuery, useTheme} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import type * as React from 'react';

const Header = (): React.ReactElement => {
    const theme = useTheme();
    const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
    const {user} = useUserContext();

    if (user === undefined) {
        return <></>;
    }

    return (
        <AppBar
            sx={{
                backgroundColor: '#fff',
            }}
            elevation={0}
        >
            <Container>
                <Toolbar disableGutters>
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Logo />
                        {!user && <Box>{!isMdOrSmaller && <GuestHeaderLinks />}</Box>}
                        {user && (
                            <Box>
                                {isMdOrSmaller && <Hamburger />}
                                {!isMdOrSmaller && <UserHeaderLinks />}
                            </Box>
                        )}
                    </Stack>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
